const REMEMBER_KEY = 'db_scaffolding.auth.remember';
const REMEMBER_EMAIL_KEY = 'db_scaffolding.auth.remember_email';

export function isRemembered(): boolean {
  try {
    return localStorage.getItem(REMEMBER_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setRemember(remember: boolean): void {
  try {
    localStorage.setItem(REMEMBER_KEY, remember ? 'true' : 'false');
  } catch {}
}

export function getRememberedEmail(): string {
  try {
    return localStorage.getItem(REMEMBER_EMAIL_KEY) ?? '';
  } catch {
    return '';
  }
}

export function setRememberedEmail(email: string | null): void {
  try {
    if (email) localStorage.setItem(REMEMBER_EMAIL_KEY, email);
    else localStorage.removeItem(REMEMBER_EMAIL_KEY);
  } catch {}
}

function activeStore(): Storage {
  return isRemembered() ? localStorage : sessionStorage;
}

function otherStore(): Storage {
  return isRemembered() ? sessionStorage : localStorage;
}

function read(key: string): string | null {
  try {
    return activeStore().getItem(key) ?? otherStore().getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    activeStore().setItem(key, value);
    otherStore().removeItem(key);
  } catch {}
}

function erase(key: string): void {
  try {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  } catch {}
}

export const authStorage = {
  getItem: read,
  setItem: write,
  removeItem: erase,

  get<T>(key: string, fallback: T): T {
    const raw = read(key);
    if (raw === null) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  set(key: string, value: unknown): void {
    write(key, JSON.stringify(value));
  },
  remove(key: string): void {
    erase(key);
  },
};
